import ReportUtils from "../../../../../../utils/report-utils.js";
import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function AgentsDayOff({ data }) {
    const dayOff = data?.dayOff ?? {};
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        { headerName: "Motivo", field: "typeName", flex: 1 },
        { headerName: "Data inicial", field: "startDate", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
        { headerName: "Data final", field: "endDate", sort: "desc", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) },
    ]), [dayOff])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] mb-2">
                Ausências
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={dayOff ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    formatters={{
                        typeName: (row) => row.typeName,
                        startDate: (row) => ReportUtils.formatDateOnly(row.startDate),
                        endDate: (row) => ReportUtils.formatDateOnly(row.endDate),
                    }}
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}